import { ProductId } from '@services/MarppleShop/features/ProductMeta';

export class FundingCreator {
  public readonly storeId: number;
  public readonly productId: ProductId;
  public readonly name: string;
  public readonly domainName: string;
  public readonly createdAt: Date;

  private constructor(
    storeId: number,
    productId: ProductId,
    name: string,
    domainName: string,
    createdAt?: Date,
  ) {
    this.storeId = storeId;
    this.productId = productId;
    this.name = name;
    this.domainName = domainName;
    this.createdAt = createdAt || new Date();
  }

  static of(storeId: number, productId: ProductId, name: string, domainName: string, createdAt?: Date) {
    return new FundingCreator(storeId, productId, name, domainName, createdAt);
  }
}
